// FAQ content — ported from the old faq.js static markup into data.
// Answers are arrays of paragraphs; the support item carries a real link.

export const COMPARISON = {
  prompt: 'Мне плохо. Не знаю, что делать со своей жизнью.',
  gpt: 'Сочувствую вашему состоянию. Вот несколько рекомендаций: 1. Заведите дневник переживаний. 2. Добавьте физическую активность. 3. Обратитесь к специалисту. 4. Поделитесь с близкими…',
  hq: 'Слышу вас. Ощущение, что не понимаешь, куда двигаться — это правда тяжело, и то, что вы сейчас об этом говорите, уже важный шаг. Расскажите подробнее: когда это чувство впервые появилось? Случилось что-то конкретное, или оно подкралось постепенно?',
  callout: 'ChatGPT выдаёт готовый список советов. Humanteq ведёт диалог и помогает прийти к собственному инсайту.',
}

export interface FaqItem {
  q: string
  a: string[]
  link?: { text: string; href: string }
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    q: 'Как пользоваться Humanteq?',
    a: ['Сервис работает прямо в браузере — на телефоне или компьютере. Нажмите «Начать сейчас» — откроется мгновенно. Можно установить на экран телефона как обычное приложение: на Android — кнопка «Установить» в баннере, на iPhone — «Поделиться» → «На экран Домой».'],
  },
  {
    q: 'Как отменить подписку?',
    a: ['Отмена — в один клик в разделе «Тарифы» внутри сервиса. Без звонков и объяснений.'],
  },
  {
    q: 'Какие методики используются?',
    a: [
      'Humanteq работает на основе доказательных подходов: когнитивно-поведенческой терапии (КПТ), диалектической поведенческой терапии (ДБТ) и техник саморегуляции.',
      'Бот не даёт случайных советов — каждая практика опирается на научно подтверждённые методы и встроена в структурированный процесс: разбор ситуации → инсайт → конкретный шаг.',
    ],
  },
  {
    q: 'Может ли бот заменить психолога?',
    a: [
      'Humanteq не заменяет психотерапию и не ставит диагнозы.',
      'Он помогает в моменте: снизить тревогу, разобраться в мыслях, наметить следующий шаг. Если нужна глубокая работа — внутри сервиса можно подключить живого психолога.',
    ],
  },
  {
    q: 'Подойдёт ли мне, если я уже в терапии?',
    a: [
      'Да. Многие используют Humanteq как поддержку между сессиями.',
      'Он помогает зафиксировать мысли, пережить сложный момент и подготовиться к разговору с терапевтом: что произошло → что я почувствовал(а) → что мне важно.',
    ],
  },
  {
    q: 'Насколько конфиденциально общение с ботом?',
    a: [
      'Мы понимаем, что психологические темы — это личное. Содержимое разговоров не передаётся третьим лицам и не используется в публичных целях.',
      'Ваша переписка с ботом нужна только для того, чтобы генерировать ответы в контексте, анализировать историю диалога и автоматически улучшать качество работы бота.',
    ],
  },
  {
    q: 'Видите ли вы мои данные?',
    a: [
      'Ваши сообщения привязаны к одному анонимному ID, который дополнительно шифруется. Данные идут по зашифрованным каналам — так же, как данные онлайн-банка, перехватить переписку «по дороге» нельзя.',
      'Истории переписок не просматриваются вручную. Только вы сами можете поделиться сообщениями со службой поддержки — у неё нет доступа к вашей переписке.',
    ],
  },
  {
    q: 'Храните ли вы историю переписок?',
    a: [
      'Бот помнит прошлые сессии, чтобы поддерживать диалог: замечать динамику, не переспрашивать одно и то же, точнее подбирать техники под вашу ситуацию.',
      'Без памяти это был бы просто чат с незнакомцем каждый раз заново.',
    ],
  },
  {
    q: 'Можно ли удалить переписку?',
    a: [
      'Команда /delete_session стирает историю последней сессии.',
      'Если хотите удалить всё полностью — напишите в поддержку, мы уберём ваш профиль и всю переписку из системы без лишних вопросов.',
    ],
  },
  {
    q: 'А что с языковыми моделями?',
    a: [
      'Бот работает на больших языковых моделях — Google Gemini и DeepSeek в основном контуре, Grok и GLM как резервные.',
      'Ваша переписка хранится в нашем сервисе; для генерации ответа провайдеру модели передаются только резюме диалога и отдельное сообщение. Мы выбираем только тех провайдеров, которые не сохраняют и не используют переданные им данные пользователей.',
    ],
  },
  {
    q: 'Что делать, если остались вопросы?',
    a: ['Если у вас есть идеи и предложения по повышению конфиденциальности или удобства сервиса — будем им очень рады.'],
    link: { text: 'Напишите в поддержку в VK', href: 'https://vk.com/humanteq' },
  },
]
